import { render, staticRenderFns } from "./RewardsLayout.vue?vue&type=template&id=0e3472b1&scoped=true&"
import script from "./RewardsLayout.vue?vue&type=script&lang=js&"
export * from "./RewardsLayout.vue?vue&type=script&lang=js&"
import style0 from "./RewardsLayout.vue?vue&type=style&index=0&id=0e3472b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3472b1",
  null
  
)

export default component.exports